export default function removeURLSearchParam(name: string) {
    const url = new URL(window.location.href)
    url.searchParams.delete(name)
    window.history.replaceState({}, "", url)
}
